import take from 'lodash/take'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useToggle } from 'react-use'

export const useShowMore = ({ items, limit = 5 }) => {
  const [isOpenMore, setIsOpenMore] = useToggle(false)
  const [newItems, setNewItems] = React.useState([])

  React.useEffect(() => {
    if (!isEmpty(items)) {
      setNewItems(items)
    }
  }, [items])

  React.useEffect(() => {
    if (isOpenMore) {
      setNewItems(items)
    } else {
      const takeFive = take(items, limit) ?? []
      setNewItems(takeFive)
    }
  }, [items, isOpenMore, limit])

  return { newItems, isOpenMore, setIsOpenMore }
}
